// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BREAKPOINTS */
.UserMenu_userCard__nwrHN {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: inset 0 -3px 3px -3px rgba(0, 0, 0, 0.25);
  padding: 0.5em 1em;
}
.UserMenu_userCard__nwrHN > * + * {
  margin-top: 0.25em;
}
.UserMenu_userCard__nwrHN .UserMenu_userAvatar__7GEnr {
  --size: 80px;
  width: var(--size);
  height: var(--size);
  background: var(--danger);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 2em;
  font-weight: var(--bold);
  color: var(--background-color-1);
}
.UserMenu_userCard__nwrHN .UserMenu_userType__MOKdx {
  font-size: 0.75em;
}

.UserMenu_userMenu__L6kw3 {
  grid-area: user;
}
.UserMenu_userMenu__L6kw3 > div {
  display: flex;
  align-items: center;
  height: 100%;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK {
  cursor: pointer;
  background: none;
  color: var(--white);
  display: grid;
  grid-template: "info avatar"/auto auto;
  grid-gap: 4px;
  gap: 4px;
  padding: 0;
  border: none;
  border-top-right-radius: 1000px;
  border-bottom-right-radius: 1000px;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_info__N9zYz {
  grid-area: info;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}
@media (max-width: 767.98px) {
  .UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_info__N9zYz {
    display: none;
  }
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_info__N9zYz .UserMenu_type__GqvwX {
  font-size: 0.625em;
  background: var(--warn);
  padding: 4px;
  border-radius: 4px;
  color: black;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- {
  grid-area: avatar;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 1000px;
  padding: 2px;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q {
  position: relative;
  width: 44px;
  height: 44px;
  margin-right: 4px;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  display: block;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: var(--white);
  z-index: -1;
  border: 0 solid var(--warn);
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q > * {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q > img {
  object-fit: cover;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q > div {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--bold);
  color: var(--background-color-1);
  background: var(--danger);
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK:focus, .UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK.focus-visible {
  outline: none;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK:hover, .UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK.focus-visible {
  transition: all 0.3s ease;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK:hover .UserMenu_buttonMain__DFKL-, .UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK.focus-visible .UserMenu_buttonMain__DFKL- {
  color: var(--darkgray);
  transition: all 0.3s ease;
}
.UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK:hover .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q::before, .UserMenu_userMenu__L6kw3 > div .UserMenu_userButton__ZfIHK.focus-visible .UserMenu_buttonMain__DFKL- .UserMenu_avatar__RAx-q::before {
  --size: 150px;
  transition: all 0.3s ease;
  width: var(--size);
  height: var(--size);
  margin-top: calc(-0.5 * var(--size));
  margin-left: calc(-0.5 * var(--size));
  border-width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/core/_breakpoints.scss","webpack://./src/views/Template/components/Menu/UserMenu.module.scss"],"names":[],"mappings":"AAAA,gBAAA;ACCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qDAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AAAE;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,gCAAA;AAEJ;AAAE;EACE,iBAAA;AAEJ;;AACA;EACE,eAAA;AAEF;AADE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAGJ;AAFI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sCAAA;EACA,aAAA;EAAA,QAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,kCAAA;AAIN;AAHM;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;AAKR;AD5BI;ECiBE;IAQI,aAAA;EAOR;AACF;AANQ;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAQV;AALM;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAOR;AANQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAQV;AAPU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,wBAAA;EACA,WAAA;EACA,2BAAA;AASZ;AAPU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AASZ;AAPU;EACE,iBAAA;AASZ;AAPU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,yBAAA;AASZ;AALM;EAEE,aAAA;AAMR;AAJM;EAEE,yBAAA;AAKR;AAJQ;EACE,sBAAA;EACA,yBAAA;AAMV;AAJY;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qCAAA;EACA,kBAAA;AAMd","sourcesContent":["/* BREAKPOINTS */\n@mixin breakpoint-up($point) {\n  @if $point == sm {\n    @media (min-width: 576px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (min-width: 768px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (min-width: 992px) {\n      @content;\n    }\n  } @else if $point == xl {\n    @media (min-width: 1200px) {\n      @content;\n    }\n  }\n}\n\n@mixin breakpoint-down($point) {\n  @if $point == xs {\n    @media (max-width: 575.98px) {\n      @content;\n    }\n  } @else if $point == sm {\n    @media (max-width: 767.98px) {\n      @content;\n    }\n  } @else if $point == md {\n    @media (max-width: 991.98px) {\n      @content;\n    }\n  } @else if $point == lg {\n    @media (max-width: 1199.98px) {\n      @content;\n    }\n  }\n}\n","@import \"core/_breakpoints.scss\";\n.userCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-shadow: inset 0 -3px 3px -3px rgba(black, 0.25);\n  padding: 0.5em 1em;\n  > * + * {\n    margin-top: 0.25em;\n  }\n  .userAvatar {\n    --size: 80px;\n    width: var(--size);\n    height: var(--size);\n    background: var(--danger);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    font-size: 2em;\n    font-weight: var(--bold);\n    color: var(--background-color-1);\n  }\n  .userType {\n    font-size: 0.75em;\n  }\n}\n.userMenu {\n  grid-area: user;\n  > div {\n    display: flex;\n    align-items: center;\n    height: 100%;\n    .userButton {\n      cursor: pointer;\n      background: none;\n      color: var(--white);\n      display: grid;\n      grid-template: \"info avatar\" / auto auto;\n      gap: 4px;\n      padding: 0;\n      border: none;\n      border-top-right-radius: 1000px;\n      border-bottom-right-radius: 1000px;\n      .info {\n        grid-area: info;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        justify-content: center;\n        @include breakpoint-down(sm) {\n          display: none;\n        }\n        .type {\n          font-size: 0.625em;\n          background: var(--warn);\n          padding: 4px;\n          border-radius: 4px;\n          color: black;\n        }\n      }\n      .buttonMain {\n        grid-area: avatar;\n        display: flex;\n        align-items: center;\n        overflow: hidden;\n        border-radius: 1000px;\n        padding: 2px;\n        .avatar {\n          position: relative;\n          width: 44px;\n          height: 44px;\n          margin-right: 4px;\n          &::before {\n            content: \"\";\n            position: absolute;\n            left: 50%;\n            top: 50%;\n            display: block;\n            width: 0;\n            height: 0;\n            border-radius: 50%;\n            background: var(--white);\n            z-index: -1;\n            border: 0 solid var(--warn);\n          }\n          > * {\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n          }\n          > img {\n            object-fit: cover;\n          }\n          > div {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-weight: var(--bold);\n            color: var(--background-color-1);\n            background: var(--danger);\n          }\n        }\n      }\n      &:focus,\n      &:global(.focus-visible) {\n        outline: none;\n      }\n      &:hover,\n      &:global(.focus-visible) {\n        transition: all 0.3s ease;\n        .buttonMain {\n          color: var(--darkgray);\n          transition: all 0.3s ease;\n          .avatar {\n            &::before {\n              --size: 150px;\n              transition: all 0.3s ease;\n              width: var(--size);\n              height: var(--size);\n              margin-top: calc(-0.5 * var(--size));\n              margin-left: calc(-0.5 * var(--size));\n              border-width: 20px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userCard": `UserMenu_userCard__nwrHN`,
	"userAvatar": `UserMenu_userAvatar__7GEnr`,
	"userType": `UserMenu_userType__MOKdx`,
	"userMenu": `UserMenu_userMenu__L6kw3`,
	"userButton": `UserMenu_userButton__ZfIHK`,
	"info": `UserMenu_info__N9zYz`,
	"type": `UserMenu_type__GqvwX`,
	"buttonMain": `UserMenu_buttonMain__DFKL-`,
	"avatar": `UserMenu_avatar__RAx-q`
};
export default ___CSS_LOADER_EXPORT___;
